import { Routes } from '@angular/router';

import { UnsavedFormGuard } from '../profile-management/guards/unsaved-form.guard';
import { DealerOnboardingGuard } from '../app/guards/dealer-onboarding/dealer-onboarding.guard';

export const dorRoutes: Routes = [
  {
    path: 'dor',
    children: [
      {
        path: 'onboarding',
        loadComponent: () => import('./components/onboarding-form/onboarding-form.component').then(c => c.OnboardingFormComponent),
        canActivate: [DealerOnboardingGuard],
        canDeactivate: [UnsavedFormGuard],
        pathMatch: 'full'
      },
      {
        path: 'signup',
        loadComponent: () => import('./components/dealer-onboarding-signup/dealer-onboarding-signup.component').then(c => c.DealerOnboardingSignupComponent),
        canActivate: [DealerOnboardingGuard],
        pathMatch: 'full'
      },
      {
        path: 'transaction-info',
        loadComponent: () => import('./components/transaction-info-shell/transaction-info-shell.component').then(c => c.TransactionInfoShellComponent),
        canActivate: [DealerOnboardingGuard],
        canDeactivate: [UnsavedFormGuard],
        pathMatch: 'full'
      },
      {
        path: 'account-created',
        loadComponent: () => import('./components/account-created/account-created.component').then(c => c.AccountCreatedComponent),
        canActivate: [DealerOnboardingGuard],
        pathMatch: 'full'
      },
      {
        path: '**',
        redirectTo: '/404',
        pathMatch: 'full'
      }
    ]
  }
];

